<template>
  <div>
    <QuestionPage
        v-if="!showResult"
        :question-data="currentQuestion"
        @answered="handleAnswer"
    />

    <ResultPage
        v-else
        :is-correct="isCorrect"
        :correct-answer="currentQuestion.answer"
        :id="currentQuestion.id"
        @next="goNext"
    />
  </div>
</template>

<script>
import QuestionPage from './questions-page.vue';
import ResultPage from './result-page.vue';
import { useRoute } from 'vue-router'

export default {
  components: {QuestionPage, ResultPage},
  data() {
    return {
      currentIndex: 0,
      showResult: false,
      isCorrect: false,
      results: [],
      questions: [
        {
          id: 1,
          question: "Ποιο έτος ιδρύθηκε η εταιρεία illycaffè;",
          answer: "<span style='font-weight:600;'>Η illycaffè ιδρύθηκε στην Τεργέστη το <span style='font-weight:800;'>1933</span> από τον Francesco Illy.</span>",
          correctAnswer: "1933",
          firstAnswer: "1943",
          secondAnswer: "1933",
          thirdAnswer: "1934"
        },
        {
          id: 2,
          question: "Από ποιους τύπους καφέ αποτελείται το χαρμάνι μας;",
          answer: "<span style='font-weight:600;'>Το χαρμάνι του illy αποτελείται αποκλειστικά από <span style='font-weight:800;'>100% Arabica καφέ.</span></span>",
          correctAnswer: "100% Arabica",
          firstAnswer: "100% Arabica",
          secondAnswer: "Arabica και Robusta",
          thirdAnswer: "Μόνο Robusta"
        },
        {
          id: 3,
          question: "Τι συμβαίνει στους κόκκους κατά το στέγνωμα;",
          answer: "<span style='font-weight:800;'>Απορροφούν θερμότητα και αναπτύσσουν αρώματα.</span>",
          correctAnswer: "Απορροφούν θερμότητα </br> & αναπτύσσουν αρώματα",
          firstAnswer: "Χάνουν άρωμα",
          secondAnswer: "Σκουραίνουν",
          thirdAnswer: "Απορροφούν θερμότητα </br> & αναπτύσσουν αρώματα"
        },
        {
          id: 4,
          question: "Πόσους ελέγχους πραγματοποιούμε πριν ο καφές φτάσει στο φλιτζάνι;",
          answer: "<span style='font-weight:600;'>Πραγματοποιούμε <span style='font-weight:800;'>340 </span> ελέγχους για να διασφαλίσουμε κορυφαία ποιότητα.</span>",
          correctAnswer: "340",
          firstAnswer: "76",
          secondAnswer: "182",
          thirdAnswer: "340"
        },
        {
          id: 5,
          question: "Πώς ονομάζεται η διαδικασία κατά την οποία οι ειδικοί μας δοκιμάζουν τον καφέ για να αξιολογήσουν το άρωμά του;",
          answer: "<span style='font-weight:600;'>Η επαγγελματική γευστική δοκιμή του καφέ ονομάζεται <span style='font-weight:800;'>cupping.</span></span>",
          correctAnswer: "Cupping",
          firstAnswer: "Καβούρδισμα",
          secondAnswer: "Δοκιμή",
          thirdAnswer: "Cupping"
        },
        {
          id: 6,
          question: "Γιατί οι ειδικοί μας μυρίζουν τους κόκκους;",
          answer: "<span style='font-weight:800;'>Για να αναγνωρίσουν το κυρίαρχο άρωμα.</span>",
          correctAnswer: "Για να εντοπίσουν το </br> κυρίαρχο άρωμα",
          firstAnswer: "Για να αξιολογήσουν την </br> υγρασία τους",
          secondAnswer: "Για να εντοπίσουν το </br> κυρίαρχο άρωμα",
          thirdAnswer: "Για να ελέγξουν </br> το βάρος τους"
        },
        {
          id: 7,
          question: "Πότε ο κόκκος καφέ απελευθερώνει το άρωμά του;",
          answer: "<span style='font-weight:800;'>Κατά το καβούρδισμα <span style='font-weight:600;'>ο κόκκος απελευθερώνει το χαρακτηριστικό του άρωμα.</span></span>",
          correctAnswer: "Κατά το καβούρδισμα",
          firstAnswer: "Κατά το στέγνωμα",
          secondAnswer: "Κατά το καβούρδισμα",
          thirdAnswer: "Κατά την άλεση"
        },
        {
          id: 8,
          question: "Τι επιτρέπει η μέθοδος υπό πίεση, εκτός από τη διατήρηση του αρώματος;",
          answer: "<span style='font-weight:800;'>Ενισχύει τα αρώματα με την πάροδο του χρόνου.</span>",
          correctAnswer: "Ενίσχυση των αρωμάτων </br> με την πάροδο του χρόνου",
          firstAnswer: "Μείωση της πικράδας",
          secondAnswer: "Ενίσχυση των αρωμάτων </br> με την πάροδο του χρόνου",
          thirdAnswer: "Μείωση της καφεΐνης"
        },
        {
          id: 9,
          question: "Ποιο στοιχείο χρησιμοποιούμε για να δημιουργήσουμε πίεση στις συσκευασίες μας;",
          answer: "<span style='font-weight:600;'>Το <span style='font-weight:800;'>άζωτο </span> δημιουργεί πίεση στις συσκευασίες, διατηρώντας τον καφέ φρέσκο.</span>",
          correctAnswer: "Άζωτο",
          firstAnswer: "Διοξείδιο του άνθρακα",
          secondAnswer: "Οξυγόνο",
          thirdAnswer: "Άζωτο"
        }
      ],
      questionsEn: [
        {
          id: 1,
          question: "In what year was illycaffè founded?",
          answer: "<span style='font-weight:600;'>Illycaffè was founded in Trieste in <span style='font-weight:800;'>1933</span> by Francesco Illy.</span>",
          correctAnswer: "1933",
          firstAnswer: "1943",
          secondAnswer: "1933",
          thirdAnswer: "1934"
        },
        {
          id: 2,
          question: "What kind of coffee bean is used in the illy blend?”",
          answer: "<span style='font-weight:600;'>The illy blend is made exclusively with <span style='font-weight:800;'>100% Arabica coffee.</span></span>",
          correctAnswer: "100% Arabica",
          firstAnswer: "100% Arabica",
          secondAnswer: "Arabica and Robusta",
          thirdAnswer: "Only Robusta"
        },
        {
          id: 3,
          question: "What happens to the beans during drying?",
          answer: "<span style='font-weight:800;'>During drying the beans absorb heat and develop aromas.</span>",
          correctAnswer: "They absorb heat </br> and develop aromas",
          firstAnswer: "They lose aroma",
          secondAnswer: "They darken",
          thirdAnswer: "They absorb heat </br> and develop aromas"
        },
        {
          id: 4,
          question: "How many checks do we run before coffee reaches the cup?",
          answer: "<span style='font-weight:600;'>We run <span style='font-weight:800;'>340 </span> checks to ensure top quality.</span>",
          correctAnswer: "340",
          firstAnswer: "76",
          secondAnswer: "182",
          thirdAnswer: "340"
        },
        {
          id: 5,
          question: "What is the process called where experts taste coffee to assess aroma?",
          answer: "<span style='font-weight:600;'>Professional coffee tasting is called <span style='font-weight:800;'>cupping.</span></span>",
          correctAnswer: "Cupping",
          firstAnswer: "Roasting",
          secondAnswer: "Tasting",
          thirdAnswer: "Cupping"
        },
        {
          id: 6,
          question: "Why do our experts smell the beans?",
          answer: "<span style='font-weight:800;'>To identify the dominant aroma, our experts smell the beans.</span>",
          correctAnswer: "To identify the dominant aroma",
          firstAnswer: "To assess moisture",
          secondAnswer: "To identify the dominant aroma",
          thirdAnswer: "To check weight"
        },
        {
          id: 7,
          question: "When does the coffee bean release its aroma?",
          answer: "<span style='font-weight:800;'>During roasting <span style='font-weight:600;'>the bean releases its distinctive aroma.</span></span>",
          correctAnswer: "During roasting",
          firstAnswer: "During drying",
          secondAnswer: "During roasting",
          thirdAnswer: "During grinding"
        },
        {
          id: 8,
          question: "What does pressurization allow, besides preserving aroma?",
          answer: "<span style='font-weight:800;'>Pressurization enhances aromas over time.</span>",
          correctAnswer: "Enhance aromas over time",
          firstAnswer: "Reduce bitterness",
          secondAnswer: "Enhance aromas over time",
          thirdAnswer: "Reduce caffeine"
        },
        {
          id: 9,
          question: "Which element do we use to pressurize our cans?",
          answer: "<span style='font-weight:600;'><span style='font-weight:800;'>Nitrogen </span> pressurizes the cans, keeping coffee fresh.</span>",
          correctAnswer: "Nitrogen",
          firstAnswer: "Carbon dioxide",
          secondAnswer: "Oxygen",
          thirdAnswer: "Nitrogen"
        }
      ],
      route: useRoute()
    };
  },
  computed: {
    currentQuestion() {
      const questions = this.route.path === '/en' ? this.questionsEn : this.questions;
      if (this.currentIndex >= questions.length) {
        return null;
      } else {
        return questions[this.currentIndex];
      }
    }
  },
  methods: {
    handleAnswer(selected) {
      this.isCorrect = selected === this.currentQuestion.correctAnswer;
      this.showResult = true;

      this.results.push({
        id: this.currentQuestion.id,
        selected,
        correct: this.isCorrect
      });

    },
    goNext() {
      this.showResult = false;
      this.currentIndex++;
      window.scrollTo(0, 0);

      const questions = this.route.path === '/en' ? this.questionsEn : this.questions;

      if (this.currentIndex >= questions.length) {
        const correctCount = this.results.filter(r => r.correct).length;
        const percentage = Math.round((correctCount / questions.length) * 100);

        this.$emit("quiz-finished", {
          results: this.results,
          percentage
        });
      }
    }
  }
};
</script>
